import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import { useController, Controller } from "react-hook-form";
import _ from "lodash";

export const AsyncSelectField = React.forwardRef((props, ref) => {
  const {
    isHighLight = false,
    title,
    style,
    type,
    errors,
    defaultValue,
    controlStyle = {},
    isDisabled = false,
    menuPlacement = "auto",
    showMenuOnTop = false,
    ...others
  } = props;
  const [debounce, setDebounce] = useState({});

  let err = _.get(errors, props.name);
  useEffect(() => {
    const { cb, delay } = debounce;
    if (cb) {
      const timeout = setTimeout(cb, delay);
      return () => clearTimeout(timeout);
    }
  }, [debounce]);

  const promiseOptions = (inputValue, callback) =>
    new Promise((resolve) => {
      setDebounce({
        cb: async () => resolve(props.search(inputValue)),
        delay: 500, // ms
      });
    });

  const customStyles = {
    control: (base, state) => ({
      ...base,
      height: !props?.isMulti ? 35 : "100%",
      minHeight: props.minHeight ? props.minHeight : 35,
      maxHeight: "100%",
      boxShadow: "none",
      background: isHighLight ? "#feffd7" : "",

      border: props.rules && err && "1px solid #dc2626",
      ...controlStyle,
    }),

    menu: (provided, state) => ({
      ...provided,
      zIndex: 50,
    }),
  };

  const getOptionLabel = (e) => {
    if (props.getOptionLabel) {
      return props.getOptionLabel(e);
    } else {
      return Array.isArray(props.showLabel)
        ? props.showLabel.map((key) => e[key]).join(" - ")
        : e[props.showLabel || "label"];
    }
  };
  return (
    <>
      <div className="flex">
        <div
          className={`relative w-full  ${
            isDisabled && " cursor-not-allowed "
          } `}
        >
          <div
            className={`pointer-events-none font-normal mb-2 ${
              props?.rules && err ? "text-red-600" : "text-gray-600"
            }`}
          >
            {title}
            {props?.rules?.required?.value === true && (
              <span className="text-red-500 p-2">*</span>
            )}
          </div>
          <Controller
            name={props?.name}
            rules={props?.rules}
            control={props?.control}
            defaultValue={defaultValue}
            render={({ field }) => (
              <AsyncSelect
                {...field}
                {...others}
                menuIsOpen={props.menuIsOpen || undefined}
                ref={(e) => {
                  field?.ref(e);
                  if (ref) {
                    ref.current = e;
                  }
                }}
                menuPortalTarget={showMenuOnTop && document.body}
                cacheOptions={props?.optionData?.length > 0}
                style={{
                  width: "100vw",
                }}
                noOptionsMessage={() => null}
                isMulti={props?.isMulti}
                styles={customStyles}
                loadOptions={promiseOptions}
                openMenuOnFocus={props?.optionData?.length > 0}
                placeholder=""
                menuPlacement={menuPlacement}
                classNamePrefix="select"
                isClearable
                onFocus={(e) => {
                  if (props.onFocus) {
                    props.onFocus(e);
                  }
                }}
                onBlur={() => {
                  if (props?.onBlur) {
                    props?.onBlur();
                  }
                  field.onBlur();
                }}
                getOptionLabel={getOptionLabel}
                getOptionValue={(option) => option[props.showLabel || "label"]}
                isDisabled={isDisabled ? isDisabled : false}
                defaultOptions={props.optionData ? props.optionData : ""}
                isOptionDisabled={(option) =>
                  option?.code_system && option?.code_system == "icd9"
                }
                onChange={(e) => {
                  field.onChange(e);
                  if (props.onChange) {
                    props.onChange(e);
                  }
                }}
              />
            )}
          />
        </div>
        <p className=" text-xs text-red-600 h-3" id="email-error">
          {props.rules && err && props.rules && err?.message}
        </p>
      </div>
    </>
  );
});
